import AccountPrivateRoute from './AccountPrivateRoute';
export default AccountPrivateRoute;
